import { EmptyLayout } from "../components/molecules";
import { menuAltIcon } from "../assets/icons";
import { ROUTES } from "../constants";

const { DATAMODELS } = ROUTES;

export const renderNoDataModelLayout = (navigate) => (
  <EmptyLayout
    title="Database Doesn't Exists!"
    subTitle="You can access the available data models on 'Data Models' page"
    buttonText="Go to Data Models page"
    image={menuAltIcon}
    handleOnClick={() => navigate(DATAMODELS)}
  />
);

export default renderNoDataModelLayout;
